function ActionsBar({ onArchive, onRestore, onInvoice, hideView = false, archived = false }) {
  const handleClick = (handler) => (event) => {
    event.stopPropagation();
    if (handler) handler();
  };

  const showArchive = Boolean(onArchive) && !archived;
  const showRestore = Boolean(onRestore) && archived;
  const showInvoice = !hideView && (Boolean(onInvoice) || !archived);

  return (
    <div className="row-actions" aria-label="Actions">
      {showArchive ? (
        <button aria-label="Archive" onClick={handleClick(onArchive)}>
          🗑 Archive
        </button>
      ) : null}
      {showRestore ? (
        <button aria-label="Restore" onClick={handleClick(onRestore)}>
          ♻️ Restore
        </button>
      ) : null}
      {showInvoice ? (
        <button aria-label="Invoice" onClick={onInvoice ? handleClick(onInvoice) : undefined} disabled={!onInvoice}>
          🧾 Invoice
        </button>
      ) : null}
    </div>
  );
}

export default ActionsBar;
